import { InputHTMLAttributes, useEffect, useState } from 'react'
import CreatableSelect from 'react-select/creatable'
import { QueryGetImovelTags } from '../../../../graphql/services/Tags'
// import { QueryGetImovelTags } from '../../../../../../graphql/services/Tags'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  defaultValue: any
  register?: any
  error?: any
  onValueChange: any
}

const GetTerrenoTagsCreatableSelect = ({
  defaultValue,
  register,
  onValueChange,
  error,
  ...props
}: InputProps) => {
  const [tags, setTags] = useState([])
  const [tagsSelected, setTagsSelected] = useState([])
  const { data } = QueryGetImovelTags()

  useEffect(() => {
  
    if (data && tags.length === 0) {
      let tagTemp = []
      let tagSelectedTemp = []
      // eslint-disable-next-line array-callback-return
      data.GetImovelTags.map((Options) => {
        tagTemp.push({ value: Options.id, label: Options.tag })
        if (defaultValue.indexOf(Options.tag) >= 0) {
          tagSelectedTemp.push({ value: Options.id, label: Options.tag })
        }
      })
      
      if (data.GetImovelTags.length > 0){
        setTags(tagTemp)
        setTagsSelected(tagSelectedTemp)
        onValueChange(defaultValue.join(','))
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, defaultValue, onValueChange])

  useEffect(() => {
    let resultTags = tagsSelected.map((item) => {
      return item.label
    })
    onValueChange(resultTags.join())
  },[onValueChange, tagsSelected])

  if (!data) {
    return (
      <CreatableSelect
        options={[]}
        isMulti
        onChange={handleChange}
        isDisabled={true}
        placeholder='Tags'
      />
    )
  }
  function handleChange(selectedOption) {
    setTagsSelected(selectedOption)
  }

  function handleAdd(option) {
    setTags([...tags, ...[{ value: '', label: option }]])
    setTagsSelected([...tagsSelected, ...[{ value: '', label: option }]])
    let resultTags = tagsSelected.map((item) => {
      return item.label
    })
    onValueChange(resultTags.join())
  }
 

  return (
    <CreatableSelect
      menuPortalTarget={document.body}
      // styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      options={tags}
      isMulti
      value={tagsSelected}
      defaultValue={tagsSelected}
      onChange={handleChange}
      onCreateOption={handleAdd}
      placeholder='Tags'
    />
  )
}

export default GetTerrenoTagsCreatableSelect 
